/**
 * Shared constants for formation-related functionality
 *
 * These constants are used across FormationEditor, FormationsTab, and other
 * formation components to ensure consistent player type detection and coloring.
 */

/**
 * Lineman position roles (offensive line)
 * Used to determine if a player should be rendered with lineman styling
 */
export const LINEMAN_ROLES = new Set(['lt', 'lg', 'c', 'rg', 'rt'])

/**
 * Default color for new players added via the add-player tool
 */
export const DEFAULT_PLAYER_COLOR = '#FFFFFF'

/**
 * Default color for lineman positions (white)
 */
export const DEFAULT_LINEMAN_COLOR = '#FFFFFF'

/**
 * Default color for skill player positions (blue)
 */
export const DEFAULT_SKILL_PLAYER_COLOR = '#3b82f6'

/**
 * Derives the appropriate default color based on player role
 */
export function getDefaultColorForRole(role: string): string {
	const roleLower = role.toLowerCase()
	return LINEMAN_ROLES.has(roleLower) ? DEFAULT_LINEMAN_COLOR : DEFAULT_SKILL_PLAYER_COLOR
}

/**
 * Checks if a role is a lineman position
 */
export function isLinemanRole(role: string): boolean {
	return LINEMAN_ROLES.has(role.toLowerCase())
}
